/**
 * Login workflow — orchestrates the login, token persistence, and
 * password-reset detection flow.
 *
 * Used by LoginPage to keep UI-level code focused only on rendering.
 */

import { loginApi, saveTokens, saveAuthUser } from "../services/authService";

/**
 * Execute the full login workflow.
 *
 * 1. Call the login API.
 * 2. Persist tokens to localStorage.
 * 3. Cache basic user info.
 * 4. Return a result object the caller can act on.
 *
 * @param {string} username - Login ID.
 * @param {string} password - Plain text password.
 * @returns {Promise<{
 *   username: string,
 *   mustResetPassword: boolean,
 *   accessToken: string,
 *   userId: string,
 *   roles: string[],
 * }>}
 */
export const executeLogin = async (username, password) => {
  const data = await loginApi(username, password);

  // Persist tokens
  saveTokens(data);
  saveAuthUser({
    user_id: data.user_id || "",
    username: data.username || username,
    roles: data.roles || ["user"],
  });

  return {
    username: data.username || username,
    mustResetPassword: Boolean(data.must_reset_password),
    accessToken: data.access_token,
    userId: data.user_id || "",
    roles: data.roles || ["user"],
  };
};
